import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { useContext } from './useFormContext';

const LABELS: Record<string, Record<string, string>> = {
  webmoney: { USD: 'USD (WMZ)', mBTC: 'mBTC (WMX)', WMT: 'WMT' },
  default: {
    USDC: 'USDC (ERC-20)',
    USDCBASE: 'USDC (BASE)',
    USDCS: 'USDC (SOL)',
    USDCP: 'USDC (POL)',
    USDG: 'USDG (ERC-20)',
    USDTP: 'USDT (POL)',
    USDTB: 'USDT (BEP-20)',
    USDTE: 'USDT (ERC-20)',
    USDTS: 'USDT (Solana)',
    USDTT: 'USDT (TRC-20)',
    USDTTON: 'USDT (TON)',
    USDT: 'USDT (Omni)',
    BUSD: 'BUSD (Binance)',
  },
};

const currencyLabel = (paysystem: string, currency: string) =>
  (LABELS[paysystem.replace(/_deposit$|_withdrawal$/, '')] || LABELS.default)[currency] || currency;

const Currencies: FC<{ value: string; onChange: (v: string) => void }> = ({ value, onChange }) => {
  const { locales, paysystem, currencies } = useContext();

  if (currencies.length < 2) return <input type="hidden" value={value} name="vendor_currency" />;

  return (
    <div className={classnames({ error: !value }, 'rs-column-small-12 input')}>
      <label htmlFor="vendor_currency">{`${locales.currencies_label}:`}</label>
      <div className="currencies">
        {currencies.map((c) => (
          <label key={c}>
            <input
              type="radio"
              name="vendor_currency"
              value={c}
              checked={value === c}
              onChange={(e) => onChange(e.target.value)}
            />
            {currencyLabel(paysystem, c)}
          </label>
        ))}
      </div>
    </div>
  );
};

export default Currencies;
